export default {
  "cat.shoes": "Zapatos",
  "cat.hoodies": "Sudaderas/Jerséis",
  "cat.tshirts": "Camisetas",
  "cat.jackets": "Chaquetas",
  "cat.pants": "Pantalones/Shorts",
  "cat.headwear": "Gorras/Sombreros",
  "cat.sets": "Conjuntos",
  "cat.underwear": "Ropa interior/Calzoncillos",
  "cat.jersey": "Camiseta deportiva",
  "cat.accessories": "Accesorios",
  "cat.bags": "Bolsos",
  "cat.belts": "Cinturones",
  "cat.perfumes": "Perfumes",
  "cat.other": "Otras cosas",
};